import { createSearchParams, useNavigate } from "react-router-dom-v5-compat";

import { TaskDetails } from "@fartherfinance/frontend/api/TaskWorkflows/Types";
import { TaskId } from "@fartherfinance/frontend/api/Types";

type NavigateTaskDetailsState = {
  from: "CREATE_SUBTASK";
};

export const useTasksNavigation = () => {
  const navigate = useNavigate();

  const handleNavigateToTasksList = (): void => {
    navigate({
      pathname: "/Advisor/Tasks",
      search: location.search,
    });
  };

  const handleNavigateToTaskDetails = (
    taskId: TaskId,
    state?: NavigateTaskDetailsState
  ): void => {
    navigate(
      `/Advisor/Tasks/${taskId}?${createSearchParams(location.search)}`,
      {
        state,
      }
    );
  };

  const handleNavigateToTaskCreation = (): void => {
    navigate({
      pathname: "/Advisor/Tasks/CreateTask",
      search: location.search,
    });
  };

  const handleNavigateToSubtaskCreation = (taskDetails: TaskDetails): void => {
    navigate(
      `/Advisor/Tasks/CreateSubtask?${createSearchParams(location.search)}`,
      {
        state: {
          type: "subtask",
          taskDetails,
        },
      }
    );
  };

  return {
    handleNavigateToTasksList,
    handleNavigateToTaskDetails,
    handleNavigateToTaskCreation,
    handleNavigateToSubtaskCreation,
  };
};
